import React, { useState } from "react";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { setCustomPollKey, setCustomPollShow } from "../../redux/slices/tempSlice";
import styles from "./CustomPoll.module.scss";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Background1 from "../../assets/images/Background1.jpg";

const CustomPoll = () => {
	const dispatch = useDispatch();
	const [button1, setButton1] = useState("");
	const [button2, setButton2] = useState("");
	const [button3, setButton3] = useState("");
	const [button4, setButton4] = useState("");
	const [addButton, setAddButton] = useState(0);

	const location = useLocation();
	const fileData = location.state?.fileData;
	const fileType = location.state?.fileType;
	const navigate = useNavigate();

	const bgImage = useMemo(() => {
		if (fileData && typeof fileData !== 'string') {
			try {
				return URL.createObjectURL(fileData);
			} catch (e) {
				return Background1;
			}
		}
		if (typeof fileData === 'string') return fileData;
		return Background1;
	}, [fileData]);

	const handelContinue = () => {
		const customPollData = [];
		if (button1 !== "") customPollData.push(button1);
		if (button2 !== "") customPollData.push(button2);
		if (addButton >= 1 && button3 !== "") customPollData.push(button3);
		if (addButton >= 2 && button4 !== "") customPollData.push(button4);
		
		dispatch(setCustomPollKey(customPollData));
		dispatch(setCustomPollShow({ enableCustomPoll: true, customPollPopupShow: false }));
		
		navigate("/UploadPost", {
			state: {
				...location.state,
				fileData,
				fileType,
				enablePoll: true,
				customPoll: true
			}
		});
	};

	const handelCancel = () => {
		dispatch(setCustomPollShow({ enableCustomPoll: false, customPollPopupShow: false }));
		navigate("/UploadPost", {
			state: { ...location.state, fileData, fileType }
		});
	};

	return (
		<div
			className={styles.CustomPollWrapper}
			onClick={handelCancel}
			style={{
				backgroundImage: `url(${bgImage})`,
				backgroundSize: "cover",
				backgroundPosition: "center"
			}}
		>
			<div className={styles.CustomPoll} onClick={(e) => e.stopPropagation()}>
				<div className={styles.Top}>
					<h1>Custom Poll</h1>
					<p>Min 2 and Max 4 Button </p>
				</div>

				<div className={styles.Middle}>
					<input
						type="text"
						placeholder="Enter button name"
						value={button1}
						onChange={(e) => setButton1(e.target.value)}
					/>
					<input
						type="text"
						placeholder="Enter button name"
						value={button2}
						onChange={(e) => setButton2(e.target.value)}
					/>
					{addButton >= 1 && (
						<input
							type="text"
							placeholder="Enter button name"
							value={button3}
							onChange={(e) => setButton3(e.target.value)}
						/>
					)}
					{addButton >= 2 && (
						<input
							type="text"
							placeholder="Enter button name"
							value={button4}
							onChange={(e) => setButton4(e.target.value)}
						/>
					)}
					{addButton <= 1 && (
						<button
							onClick={() => {
								setAddButton(addButton + 1);
							}}>
							Add Custom Name
						</button>
					)}
				</div>

				<div className={styles.Bottom}>
					<button type="button" onClick={handelCancel}>
						Cancel
					</button>
					<button type="button" onClick={handelContinue}>
						Continue
					</button>
				</div>
			</div>
		</div>
	);
};

export default CustomPoll;


